// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import UserRolesEditScreen from "../../src/screens/user-roles/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} UserRoleNewRouteProps */

/** @typedef {Record<string, never>} UserRoleNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<UserRoleNewRouteProps, UserRoleNewRouteState>}
 */
class UserRoleNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Add new user role")}</ScreenTitle>
        <UserRolesEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<UserRoleNewRouteProps>} */
const UserRoleNewRouteComponent = memo(shapeComponent(UserRoleNewRoute))

export default UserRoleNewRouteComponent
